import React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  className?: string;
  stepLabels?: string[];
  showLabels?: boolean;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep,
  totalSteps,
  className,
  stepLabels,
  showLabels = false,
}) => {
  return (
    <div className={cn("flex items-center justify-center", className)}>
      {Array.from({ length: totalSteps }, (_, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber < currentStep;
        const isCurrent = stepNumber === currentStep;
        const isPending = stepNumber > currentStep;

        return (
          <div key={index} className="flex items-center">
            <div className="flex flex-col items-center">
              <div
                className={cn(
                  "w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-200",
                  {
                    "bg-sauna-orange text-white": isCompleted || isCurrent,
                    "bg-sauna-beige text-sauna-navy": isPending,
                  }
                )}
              >
                {isCompleted ? (
                  <Check className="w-4 h-4" />
                ) : (
                  stepNumber
                )}
              </div>
              {showLabels && stepLabels && stepLabels[index] && (
                <span
                  className={cn(
                    "text-xs mt-1 text-center max-w-16",
                    {
                      "text-sauna-orange font-medium": isCompleted || isCurrent,
                      "text-sauna-navy/60": isPending,
                    }
                  )}
                >
                  {stepLabels[index]}
                </span>
              )}
            </div>
            {index < totalSteps - 1 && (
              <div
                className={cn(
                  "w-12 h-1 mx-2 transition-all duration-200",
                  {
                    "bg-sauna-orange": isCompleted,
                    "bg-sauna-beige": !isCompleted,
                  }
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StepIndicator; 